import { render, staticRenderFns } from "./ReportTableDowntimeByProduct.vue?vue&type=template&id=8d56bcd4&"
import script from "./ReportTableDowntimeByProduct.vue?vue&type=script&lang=js&"
export * from "./ReportTableDowntimeByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports